import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Button, Column, Form, Input, Modal } from '../../..'
import Expander from '../../../Expander'
import ChainList from './ChainList'

const { FormGroup, FormHeader, Label } = Form

class ChannelsForm extends PureComponent {
    static propTypes = {
        errors: PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
            channel_extra: PropTypes.string,
            synced: PropTypes.string,
            chain_id: PropTypes.arrayOf(PropTypes.number),
        }),
        innerRef: PropTypes.shape({}),
        isOpen: PropTypes.bool,
        isWorking: PropTypes.bool,
        values: PropTypes.shape({}),
        onChangeForm: PropTypes.shape({
            name: PropTypes.func,
            slug: PropTypes.func,
            channel_extra: PropTypes.func,
            synced: PropTypes.func,
            chain_id: PropTypes.func,
        }),
        onClickCancel: PropTypes.func,
        onClickSubmit: PropTypes.func,
        t: PropTypes.func.isRequired,
        isOpenForEdit: PropTypes.bool,
        updateValues: PropTypes.func,
    }

    static defaultProps = {
        errors: {
            name: null,
            slug: null,
            channel_extra: null,
            synced: null,
            chain_id: null,
        },
        innerRef: null,
        isOpen: false,
        isWorking: false,
        values: {},
        onChangeForm: {
            name: () => null,
            slug: () => null,
            channel_extra: () => null,
            synced: () => null,
            chain_id: () => null,
        },
        onClickCancel: () => null,
        onClickSubmit: () => null,
        updateValues: () => null,
        isOpenForEdit: false,
    }

    constructor(props) {
        super(props)

        this.updateValues = this.updateValues.bind(this)
    }

    updateValues(newForm) {
        this.setState({ values: newForm })
    }

    render() {
        const { errors, innerRef, isOpen, isWorking, onChangeForm, onClickCancel, onClickSubmit, values, t, isOpenForEdit } = this.props
        const { name: errorName, slug: errorSlug, channel_extra: errorUrl } = errors
        const { name, slug, channel_extra, chain_id } = values
        const { name: onChangeName, slug: onChangeSlug, channel_extra: onChangeUrl, chain_id: onChangeChainId } = onChangeForm

        return (
            <Modal isOpen={isOpen} onClose={onClickCancel}>
                <Form>
                    <FormHeader>{isOpenForEdit ? 'Update Channel' : 'New Channel'}</FormHeader>
                    <FormGroup title={t('Channel')}>
                        <Label id="name" label={t('Channel Name')} error={errorName}>
                            <Input ref={innerRef} id="name" name="name" type="text" error={!!errorName} onChange={onChangeName} size="md" value={name} />
                        </Label>
                        <br />
                        <Label id="chain" label="Select Chains">
                            <ChainList id="chains" name="chains" error={!!errorUrl} onChange={onChangeChainId} size="md" value={chain_id} />
                        </Label>
                        <Expander icon="cogs" header={t('Advanced options')} isOpen={false}>
                            <Label id="slug" description={t('slug-description')} label={t('Reference')} error={errorSlug}>
                                <Input id="slug" name="slug" type="text" error={!!errorSlug} onChange={onChangeSlug} size="md" value={slug} />
                            </Label>
                            <Label id="channel_extra" description={t('url-description')} label={t('url')} error={errorUrl}>
                                <Input
                                    id="channel_extra"
                                    name="channel_extra"
                                    type="text"
                                    error={!!errorUrl}
                                    onChange={onChangeUrl}
                                    size="md"
                                    value={channel_extra}
                                />
                            </Label>
                        </Expander>
                        {/*
            <Label id="slug" label="Synced" error={errorSynced}>
              <Input
                id="synced"
                name="synced"
                type="check"
                error={!!errorSynced}
                onChange={onChangeSynced}
                value={!!synced}
                checked={!!synced}
              />
            </Label> */}
                    </FormGroup>
                    <div className="modal-bottom">
                        <FormGroup>
                            <Column right width="100%">
                                <Button theme="secondary" onClick={onClickCancel} size="sm" disabled={isWorking}>
                                    Cancel
                                </Button>
                                <Button
                                    onClick={onClickSubmit}
                                    size="sm"
                                    id="create-channel-button"
                                    theme={isWorking ? 'loading' : 'forestGreen'}
                                    disabled={isWorking}
                                >
                                    {isWorking ? '...' : isOpenForEdit ? 'Update' : 'Create'}
                                </Button>
                            </Column>
                        </FormGroup>
                    </div>
                </Form>
            </Modal>
        )
    }
}

// eslint-disable-next-line react/no-multi-comp
export default React.forwardRef((props, ref) => <ChannelsForm innerRef={ref} {...props} />)
